export default __webpack_public_path__ + "static/broadcastImg2-e0692efb6dfb3044ce93c08ccf24728f.webp";